import { useState, type ReactNode } from 'react';
import { ConfirmDialog } from './ConfirmDialog';
import { useSession } from './WorkforceContext';

/**
 * Tombol Keluar + konfirmasi — SATU sumber, dipakai `MenuPage` (lewat tab "Lainnya") dan
 * `Sidebar` (desktop Owner/Manajer).
 *
 * DIEKSTRAK KARENA WKF-002 (#1155, audit peran 14 Sep 2026): sebelum ini, Keluar HANYA hidup di
 * `MenuPage`, yang hanya terjangkau lewat `BottomNav`. `BottomNav` disembunyikan lewat CSS untuk
 * Owner/Manajer begitu layar cukup lebar untuk `Sidebar` (`.shell-oversight .bottom-nav { display:
 * none }`, ≥1024px) — dan `Sidebar` sendiri tidak pernah menyalin tombol ini. Pengawas di desktop
 * kehilangan SATU-SATUNYA jalan sampai ke akunnya sendiri untuk keluar: bukan tersembunyi, betul-
 * betul tak terjangkau lewat klik mana pun tanpa mengetik `/menu` langsung di alamat.
 *
 * Perangkat sering dipakai bersama di lapangan — Keluar yang tertekan tanpa sengaja mengusir
 * orang di tengah shift-nya. Konfirmasi ini murni jaring pengaman ketukan; belum tentu keliru,
 * tapi mahal untuk dibatalkan (harus masuk lagi dari nol).
 *
 * `className` default MENIRU PERSIS `.header-signout` milik `MenuPage` — kelas itu sudah tiga
 * kali diperbaiki gara-gara kontras yang hilang (lihat `styles.css`), jadi tempat baru ini
 * memakai ulang bentuk yang sudah terbukti benar alih-alih mengarang gaya ketiga.
 */
export function SignOutButton({
  className = 'header-signout',
}: {
  readonly className?: string;
}): ReactNode {
  const session = useSession();
  const [confirmSignOut, setConfirmSignOut] = useState(false);

  return (
    <>
      <button type="button" className={className} onClick={() => setConfirmSignOut(true)}>
        Keluar
      </button>
      <ConfirmDialog
        open={confirmSignOut}
        title="Keluar dari akun?"
        message="Anda perlu masuk kembali dengan email dan kata sandi untuk melanjutkan."
        confirmLabel="Ya, keluar"
        onConfirm={() => {
          setConfirmSignOut(false);
          session.onSignOut();
        }}
        onDismiss={() => setConfirmSignOut(false)}
      />
    </>
  );
}
